export default __webpack_public_path__ + "static/tech-3-dcf69b283597b95dd8803ef6d7f8631e.jpg";